import { createScript } from './create-script.service';
import { deleteAttachedFile } from './delete-attached-file';
import { deleteScript } from './delete-script.service';
import { generateScript } from './generate-script.service';
import { getContextConfigurationScript } from './get-context-configuration-script.service';
import { getScripts } from './get-scripts.service';
import { regenerateScriptItem } from './regenerate-script-item.service';
import { regenerateScript } from './regenerate-script.service';
import { updateContextConfigurationScript } from './update-context-configuration-script.service';
import { updateScript } from './update-script.service';
import { updateVoiceAssociate } from './update-voice-associate.service';
import { uploadAttachedFile } from './upload-attached-file';

export const scriptsService = {
  getScripts,
  updateScript,
  deleteScript,
  createScript,
  generateScript,
  regenerateScript,
  uploadAttachedFile,
  deleteAttachedFile,
  updateVoiceAssociate,
  regenerateScriptItem,
  getContextConfigurationScript,
  updateContextConfigurationScript,
};
